<div class="cart-container">
  <div class="cart-btn-icon" [ngClass]="{'bg-white' : isCustom ,'cart-not-empty orange-shadow' : cart?.totalElements > 0 && !isCustom && !isMiddleScreeen, 'cart-empty' : !cart?.totalElements || isCustom || isMiddleScreeen }"
    (click)="onToggleShowCart()">
    @if(!isCustom){
      <img [src]="isHeaderBreakpoint ? 'assets/images/cart-blue.svg' : (cart.totalElements > 0 ? 'assets/images/cart.svg' : 'assets/images/cart-empty.svg')"
      class="cart-img" alt="">
    } @else {
      <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
        <path d="M1 1L3.08 1.35589L4.043 12.698C4.12 13.6243 4.903 14.3351 5.843 14.3322H16.752C17.649 14.3341 18.41 13.6817 18.537 12.8038L19.486 6.32061C19.592 5.59597 19.083 4.92373 18.351 4.81894C18.287 4.81004 3.414 4.8051 3.414 4.8051" [attr.stroke]="customDataPage.mainColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12.375 8.45914H15.148" [attr.stroke]="customDataPage.mainColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.40338 17.7598C5.70438 17.7598 5.94738 18.001 5.94738 18.2976C5.94738 18.5951 5.70438 18.8363 5.40338 18.8363C5.10238 18.8363 4.85938 18.5951 4.85938 18.2976C4.85938 18.001 5.10238 17.7598 5.40338 17.7598Z" [attr.fill]="customDataPage.mainColor" [attr.stroke]="customDataPage.mainColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.6846 17.7598C16.9856 17.7598 17.2296 18.001 17.2296 18.2976C17.2296 18.5951 16.9856 18.8363 16.6846 18.8363C16.3836 18.8363 16.1406 18.5951 16.1406 18.2976C16.1406 18.001 16.3836 17.7598 16.6846 17.7598Z" [attr.fill]="customDataPage.mainColor" [attr.stroke]="customDataPage.mainColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    }
    @if (cart.totalElements) {
      <span class="cart-icon-total-items">{{ cart.totalElements }}</span>
    }
  </div>
  @if (showCart) {
    @if (isSmallScreen) {
      <div class="cart-bottom-sheet-modal" [ngClass]="{'closing': slideBottomSheetModal === 'down'}">
        <div class="bottom-sheet-modal-container"
          [ngClass]="{'empty-cart': (showLoadingCart || cart?.totalElements === 0)}"
          [@slideUpAnimationFast]="cartItems.length === 0 ? slideBottomSheetModal : undefined" 
          [@slideUpAnimation]="cartItems.length > 0 ? slideBottomSheetModal : undefined">
          <div class="rounded-x" style="top: -30px;" (click)="closeCartModal()">
            <span class="line line1"></span><span class="line line2"></span>
          </div>
          <ng-container *ngTemplateOutlet="cartModalContent"></ng-container>
        </div>
      </div>
    } @else {
      <div class="cart-dropdown-modal">
        <div class="dropdown-modal-container"
          [ngClass]="{'closing': isClosingDropdownModal, 'empty-cart': (showLoadingCart || cart?.totalElements === 0)}">
          <ng-container *ngTemplateOutlet="cartModalContent"></ng-container>
        </div>
      </div>
    }
  }
</div>

<ng-template #cartModalContent>
  @if (cart?.totalElements > 0 && cartItems?.length > 0 && !showLoadingCart) {
    <div class="timer-container">
      <app-checkout-timer [cartDurationTimer]="cart?.cartDurationTimer" [isCartSummary]="true"></app-checkout-timer>
    </div>
    <div class="cart-items-container thin-v-scrollbar" [appPreventParentScroll]="true">
      @for (item of cartItems; track item.resourceId) {
        <div class="cart-item mb-20" [class.fade-out]="fadingOutItems.has(item.resourceId)">
          <app-curved-header
            [title]="item.description"
            [color]="item.ticketingTypeColor || '#125896'">
          </app-curved-header>

          <div class="elimina-btn" [id]="'info-' + item.resourceId" (click)="onDeleteCartItems(false, item)">
            <span class="elimina-text">
              {{'selling.delete' | translate}}
            </span>
            <span class="x">×</span>
          </div>

          <div class="body-cart">
            <app-cart-item-details [item]="item" [isMobileScreenSize]="isSmallScreen" [isSummaryCart]="true" ></app-cart-item-details>
          </div>
        </div>
      }
    </div>
    <div class="cart-actions">
      <div class="commission-price-container">
        <div style="flex: 1 1 50%;" class="d-flex justify-content-between align-items-baseline">
          <span class="fz-12">{{ 'selling.commission_label' | translate }}</span>
          <div style="width: fit-content; height: 18px;" class="div1 commission-total" [innerHTML]="(cart.commissionAmount || 0) | number:'1.2-2':'it' | splitDecimal"> € </div>
        </div>
        <div style="border-left: 1px solid #D9DBDF; height: 24px;"></div>
        <div style="flex: 1 1 50%;" class="total-field d-flex justify-content-between align-items-baseline">
          <span class="fz-14">{{ 'selling.total' | translate }}</span>
          <div style="width: fit-content; height: 21px;" class="div1 fz-18 total-amount" [innerHTML]="(cart.amount || 0) | number:'1.2-2':'it' | splitDecimal"> € </div>
        </div>
      </div>
      <div class="text-center final-buttons p-0">
        <button class="btn-outlined-orange text-uppercase" (click)="onDeleteCartItems(true)">
          {{ 'selling.delete_cart' | translate }}
        </button>
        <button [routerLink]="'/carrello'" class="btn-orange orange-shadow text-uppercase" (click)="closeCartModal()">
          {{'selling.buy' | translate }}
        </button>
      </div>
    </div>
  } @else {
    <div class="w100 h100 flex-column" [appPreventParentScroll]="true">
      @if (isHeaderBreakpoint) {
        <div class="w100 d-flex align-items-center pl-15" style="height: 30px;">
          <img src="assets/images/cart-blue.svg" alt="">
          <span style="font-size: 18px; color: #004580; margin-left: 6px;">{{'seo_information.cart' | translate}}</span>
        </div>
      }
      @if (showLoadingCart) {
        <div class="loader-inline" style="margin: auto;"></div>
      } @else {
        <div class="cart-message">
          @if (!isHeaderBreakpoint) {
            <img src="assets/images/icon/svg/empty_cart_desktop.svg" width="37px" height="40px" class="mb-15">
          }
          <span>{{'selling.no_cards' | translate}}</span>
        </div>
      }
    </div>
  }
</ng-template>
